var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v("Collection Bundle (" + _vm._s(this.rules.name) + ")"),
            ]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { staticClass: "mb-4 pt-4", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12", sm: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          disabled: "",
                          label: "UID:",
                          "hide-details": "",
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.model.uid,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "uid",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.uid",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        staticClass: "mr-2",
                        attrs: { label: "Name" },
                        model: {
                          value: _vm.model.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Key" },
                        model: {
                          value: _vm.model.key,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "key",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.key",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-expansion-panels",
                [
                  _c("r-guard-panel", {
                    attrs: { model: _vm.model.guard, title: "Guard Config" },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "guard", $event)
                      },
                    },
                  }),
                  _c("r-guard-money-panel", {
                    attrs: {
                      model: _vm.model.guardMoney,
                      title: "Guard Money",
                    },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "guardMoney", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c("v-row", { staticClass: "mt-6", attrs: { dense: "" } }),
              _c(
                "v-expansion-panels",
                [
                  _c(
                    "r-panel",
                    { attrs: { title: "Sale Config" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "4", md: "4", sm: "4" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Sale Duration",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.model.saleDuration,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "saleDuration",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "model.saleDuration",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mb-4 pt-4", attrs: { dense: "" } },
                        [
                          _c("r-currency-table", {
                            attrs: {
                              items: _vm.model.cardPrice,
                              title: "Card Price",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("r-card-panel", {
                    attrs: {
                      items: _vm.model.previewCards,
                      title: "Preview Cards",
                    },
                    on: {
                      "update:items": function ($event) {
                        return _vm.$set(_vm.model, "previewCards", $event)
                      },
                    },
                  }),
                  _c("r-card-album-panel", {
                    attrs: { items: _vm.model.albums, title: "Albums" },
                    on: {
                      "update:items": function ($event) {
                        return _vm.$set(_vm.model, "albums", $event)
                      },
                    },
                  }),
                  _c("r-reward-bunch-panel", {
                    attrs: { model: _vm.model.rewardBunch, title: "Rewards" },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "rewardBunch", $event)
                      },
                    },
                  }),
                  _c("r-product-panel", {
                    attrs: {
                      items: _vm.model.shopDuplicate,
                      title: "Shop Duplicate",
                      kinds: _vm.product_groups,
                    },
                    on: {
                      "update:items": function ($event) {
                        return _vm.$set(_vm.model, "shopDuplicate", $event)
                      },
                    },
                  }),
                  _c("r-product-panel", {
                    attrs: {
                      items: _vm.model.shopCardpack,
                      title: "Shop Cardpack",
                      kinds: _vm.product_groups,
                    },
                    on: {
                      "update:items": function ($event) {
                        return _vm.$set(_vm.model, "shopCardpack", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }